import {createBrowserRouter} from "react-router";
import AppLayout from "../layout/Index-app";
import AddOnList from "../pages/mrpropfund/add-on/addOnList";
import ProductList from "../pages/mrpropfund/product/productList";
import React from "react";
import AppLayoutWithSidebar from "../layout/Index-app-with-sidebar";
import ProductAdd from "../pages/mrpropfund/product/productAdd";
import OrderList from "../pages/mrpropfund/orders/orderList";
import OrderAdd from "../pages/mrpropfund/orders/orderAdd";
import CategoryList from "../pages/mrpropfund/category/categoryList";
import CategoryAdd from "../pages/mrpropfund/category/categoryAdd";
import VarietyList from "../pages/mrpropfund/variety/varietyList";
import VarietyAdd from "../pages/mrpropfund/variety/varietyAdd";
import AddOnAdd from "../pages/mrpropfund/add-on/addOnAdd";
import InventoryList from "../pages/mrpropfund/inventory/inventoryList";
import InventoryAdd from "../pages/mrpropfund/inventory/inventoryAdd";
import CampaignList from "../pages/mrpropfund/campign/campaignList";
import CampaignAdd from "../pages/mrpropfund/campign/campaignAdd";
import DiscountList from "../pages/mrpropfund/discount/discountList";
import DiscountAdd from "../pages/mrpropfund/discount/discountAdd";
import PostList from "../pages/mrpropfund/post/postList";
import TicketList from "../pages/mrpropfund/tickets/ticketList";
import TicketChat from "../pages/mrpropfund/tickets/ticketChat";
import WithdrawListAdmin from "../pages/mrpropfund/withdraw/withdrawListAdmin";
import CloudStorage from "../pages/fxpilot/cloud-storage";
import FxpilotAppLayout from "../layout/Index-app-fxpilot";
import FxpilotAppLayoutWithSidebarBotPanel from "../layout/Index-app-fxpilot-bot-panel-with-sidebar";
import {BotInformation} from "../pages/fxpilot/bot/User-facing/EditBot/newCourseSteps/BotInformation";
import {BotImages} from "../pages/fxpilot/bot/User-facing/EditBot/newCourseSteps/BotImages";
import {BotVersions} from "../pages/fxpilot/bot/User-facing/EditBot/newCourseSteps/BotVersions";
import {BotBackTest} from "../pages/fxpilot/bot/User-facing/EditBot/newCourseSteps/BotBackTest";
import LicenseList from "../pages/fxpilot/license/license-list";
import {BotNotes} from "../pages/fxpilot/bot/User-facing/EditBot/newCourseSteps/BotNotes";
import {BotTutorials} from "../pages/fxpilot/bot/User-facing/EditBot/newCourseSteps/BotTutorials";
import EditBot from "../pages/fxpilot/bot/User-facing/EditBot";
import FxpilotAppLayoutWithSidebar from "../layout/Index-app-fxpilot-with-sidebar";
import Recharge from "../pages/fxpilot/recharge";
import MyCourses from "../pages/fxpilot/lms/courses/User-facing/MyCourses";
import CourseOverview from "../pages/fxpilot/lms/courses/User-facing/CourseOverview";
import UserIDentifyCards from "../pages/fxpilot/identify/userIDentifyCards";
import ApplicationForm from "../pages/fxpilot/identify/applicationForm";
import SignalTabs from "../pages/fxpilot/signal";
import BotList from "../pages/fxpilot/bot/bot-list";
import {CustomLogin} from "../pages/mrpropfund/login";
import {ForgotPassword2} from "../pages/mrpropfund/forgot-password";
import {ResetPassword} from "../pages/mrpropfund/reset-password";
import Error404Classic from "../pages/error/404-classic";
import Error504Classic from "../pages/error/504-classic";
import Home from "../pages/fxpilot/home";
import Wallet from "../pages/fxpilot/wallet";
import PostAdd from "../pages/mrpropfund/post/postAdd";
import EditCourse from "../pages/fxpilot/lms/courses/Admin-facing/EditCourse";
import ManageCourses from "../pages/fxpilot/lms/courses/Admin-facing/ManageCourses";
import PostSeriesList from "../pages/mrpropfund/postSeries/postSeriesList";
import PostSeriesAdd from "../pages/mrpropfund/postSeries/postSeriesAdd";
import OrderDetail from "../pages/mrpropfund/order-detail";
import Profile from "../pages/mrpropfund/profile";
import Kyc from "../pages/mrpropfund/profile/kyc";
import Analytics from "../pages/mrpropfund/analytics";
import WithdrawConfirmation from "../pages/mrpropfund/withdraw/withdrawCompfirmation";
import AccountList from "../pages/mrpropfund/accounts/accountList";
import Plans from "../pages/mrpropfund/plans";
import Checkout from "../pages/mrpropfund/checkout";
import PaymentSuccess from "../pages/mrpropfund/payment/PaymentSuccess";
import PaymentFailed from "../pages/mrpropfund/payment/PaymentFailed";
import WithdrawList from "../pages/mrpropfund/withdraw/withdrawList";
import WithdrawAdd from "../pages/mrpropfund/withdraw/withdrawAdd";
import WithdrawDetail from "../pages/mrpropfund/withdraw/withdrawDetail";
import Layout from "../layout/layout.js";
import UserList from "../pages/mrpropfund/users/userList";
import UserAdd from "../pages/mrpropfund/users/userAdd";
import GiftAccount from "../pages/mrpropfund/gift-account/userAdd";
import {BotNotesAdd} from "../pages/fxpilot/bot/User-facing/EditBot/newCourseSteps/BotNotesAdd";
import {BotMembers} from "../pages/fxpilot/bot/User-facing/EditBot/newCourseSteps/BotMembers";
import {BotMembersAdd} from "../pages/fxpilot/bot/User-facing/EditBot/newCourseSteps/BotMembersAdd";
import {BotNotesView} from "../pages/fxpilot/bot/User-facing/EditBot/newCourseSteps/BotNotesView";
import OpenPositions from "../pages/mrpropfund/logs/open-positions";
import UnhealthyAccounts from "../pages/mrpropfund/logs/unhealthy-accounts";
import {Register} from "../pages/mrpropfund/register";
import VerifyPayment from "../pages/fxpilot/recharge/verifyPayment";
import ExploreBots from "../pages/fxpilot/explore-bots";
import StrategyDetail from "../pages/fxpilot/bot-detail";
import RequestApprovalNewPublish from "../pages/fxpilot/requestApprovalNewPublish/requestApprovalNewPublish";
import RequestOrderNewStrategyCode from "../pages/fxpilot/requestOrderNewStrategyCode/User-facing/requestOrderNewStrategyCode";
import AllRequestOfOrderStrategyCode from "../pages/fxpilot/requestOrderNewStrategyCode/Admin-facing/requests";
import {InfoPage} from "../pages/fxpilot/requestOrderNewStrategyCode/Admin-facing/infoPage";
import ZarinpalVerifyPayment from "../pages/fxpilot/recharge/zarinpal-verify-payment";
import ComingSoon from "../pages/fxpilot/coming-soon";
import {BotPublication} from "../pages/fxpilot/bot/User-facing/EditBot/newCourseSteps/BotPublication";


export const router = createBrowserRouter([
    {
        path: "",
        element: <Layout/>,
        children: [

            {path: "", element: <Profile/>},
            {path: "dashboard", element: <Profile/>},
            {path: "profile/:id", element: <Profile/>},
            {path: "kyc", element: <Kyc/>},
            {path: "kyc/:id", element: <Kyc/>},
            {path: "analytics", element: <Analytics/>},
            {path: "analytics/:id/:review_id/:metaapi_server", element: <Analytics/>},
            {path: "history", element: <History/>},
            {path: "order-detail/:id", element: <OrderDetail/>},
            {path: "withdraw-confirmation/:id", element: <WithdrawConfirmation/>},
            {path: "account-list", element: <AccountList/>},
            {path: "plans", element: <Plans/>},
            {path: "checkout", element: <Checkout/>},
            {path: "payment/success/:id", element: <PaymentSuccess/>},
            {path: "payment/failed/:id", element: <PaymentFailed/>},
            {path: "withdraw-list", element: <WithdrawList/>},
            {path: "withdraw-add", element: <WithdrawAdd/>},
            {path: "withdraw-edit/:id", element: <WithdrawAdd/>},
            {path: "withdraw-detail/:id", element: <WithdrawDetail/>},
            {path: "user-list", element: <UserList/>},
            {path: "user-add", element: <UserAdd/>},
            {path: "user-edit/:id", element: <UserAdd/>},
            {path: "ticket-list", element: <TicketList/>},
            {path: "ticket-chat/:id", element: <TicketChat/>},
            {path: "profile/:role/:id", element: <Profile/>},
        ]
    },

    process.env.APPLICATION === "fxpilot" && {
        path: "",
        element: <FxpilotAppLayout/>,
        children: [
            // Routes with Standard Sidebar
            {
                element: <FxpilotAppLayoutWithSidebar/>,
                children: [
                    {path: "", element: <Home/>},
                    {path: "home", element: <Home/>},
                    {path: "wallet", element: <Wallet/>},
                    {path: "recharge", element: <Recharge/>},
                    {path: "licenses", element: <LicenseList/>},
                    {path: "course/mine", element: <MyCourses/>},
                    {path: "course/overview/:id", element: <CourseOverview/>},
                    {path: "identify", element: <UserIDentifyCards/>},
                    {path: "bots", element: <BotList/>},
                    {path: "identify/add", element: <ApplicationForm/>},
                    {path: "identify/edit/:id", element: <ApplicationForm/>},
                    {path: "signal", element: <SignalTabs/>},
                    {path: "licenses/:id", element: <LicenseList/>},
                    {path: "journal", element: <ComingSoon/>},
                    {path: "tradingview", element: <ComingSoon/>},
                    {path: "request-order-new-strategy-code", element: <RequestOrderNewStrategyCode /> },
                ],
            },
            // Routes with Bot Panel Sidebar
            {
                element: <FxpilotAppLayoutWithSidebarBotPanel/>,
                children: [
                    {path: "bot/information/:id", element: <BotInformation/>},
                    {path: "bot/images/:id", element: <BotImages/>},
                    {path: "bot/versions/:id", element: <BotVersions/>},
                    {path: "bot/publication/:id", element: <BotPublication/>},
                    {path: "bot/backtest/:id", element: <BotBackTest/>},
                    {path: "bot/licenses/:id", element: <LicenseList/>},
                    {path: "bot/members/:id", element: <BotMembers/>},
                    {path: "bot/members/add/:id", element: <BotMembersAdd/>},
                    {path: "bot/notes/:id", element: <BotNotes/>},
                    {path: "bot/notes/add/:id", element: <BotNotesAdd/>},
                    {path: "bot/notes/edit/:id/:noteId", element: <BotNotesAdd edit={true}/>},
                    {path: "bot/notes/view/:id/:noteId", element: <BotNotesView/>},
                    {path: "bot/helps/:id", element: <BotTutorials/>},
                    {path: "bots/add", element: <EditBot/>},
                    {path: "bots/edit/:id", element: <EditBot/>},
                ],
            },

            {path: "explore-bots", element: <ExploreBots/>},
            {path: "bots/:slug", element: <StrategyDetail/>},
            {path: "verify-payment", element: <VerifyPayment/>},
            {path: "zarinpal-verify-payment", element: <ZarinpalVerifyPayment/>},
        ],
    },
    {
        path: "app",
        element: <AppLayout/>,
        children: [
            {
                path: "ecommerce",
                element: <AppLayoutWithSidebar/>,
                children: [
                    {index: true, element: <ProductList/>},
                    {path: "product-list", element: <ProductList/>},
                    {path: "product-add", element: <ProductAdd/>},
                    {path: "product-edit/:id", element: <ProductAdd/>},
                    {path: "order-list", element: <OrderList/>},
                    {path: "logs/open-positions", element: <OpenPositions/>},
                    {path: "logs/unhealthy-accounts", element: <UnhealthyAccounts/>},
                    {path: "order-add", element: <OrderAdd/>},
                    {path: "order-edit/:id", element: <OrderAdd/>},
                    {path: "customer-list", element: <UserList/>},
                    {path: "customer-edit/:id", element: <UserAdd/>},
                    {path: "gift-account/:id", element: <GiftAccount/>},
                    {
                        path: "category-list",
                        element: <CategoryList section="product" createRoutePath="/app/ecommerce/category-add"/>
                    },
                    {
                        path: "category-add",
                        element: <CategoryAdd section="product" callback="/app/ecommerce/category-list"/>
                    },
                    {
                        path: "category-edit/:id",
                        element: <CategoryAdd section="product" callback="/app/ecommerce/category-list"/>
                    },
                    {
                        path: "variety-list",
                        element: <VarietyList section="product-variety" createRoutePath="/app/ecommerce/variety-add"/>
                    },
                    {
                        path: "variety-add",
                        element: <VarietyAdd section="product-variety" callback="/app/ecommerce/variety-list"/>
                    },
                    {
                        path: "variety-edit/:id",
                        element: <VarietyAdd section="product-variety" callback="/app/ecommerce/variety-list"/>
                    },
                    {path: "add-on-list", element: <AddOnList/>},
                    {path: "add-on-add", element: <AddOnAdd/>},
                    {path: "add-on-edit/:id", element: <AddOnAdd/>},
                    {path: "inventory-list/:id", element: <InventoryList/>},
                    {path: "inventory-add/:id", element: <InventoryAdd/>},
                    {path: "inventory-edit/:id", element: <InventoryAdd/>},
                    {path: "campaign-list", element: <CampaignList/>},
                    {path: "campaign-add", element: <CampaignAdd/>},
                    {path: "campaign-edit/:id", element: <CampaignAdd/>},
                    {path: "discount-list", element: <DiscountList/>},
                    {path: "discount-add", element: <DiscountAdd/>},
                    {path: "discount-edit/:id", element: <DiscountAdd/>},
                    {path: "request-publication", element: <RequestApprovalNewPublish/>},
                    {path: "all-request-of-order-strategy-code", element: <AllRequestOfOrderStrategyCode/>},
                    {path: "order/review/request-order-new-code/:id", element: <InfoPage/>},


                    process.env.APPLICATION === "fxpilot" &&
                    {
                        path: "lms",
                        children: [
                            {
                                path: "course",
                                children: [
                                    {path: "manage-courses", element: <ManageCourses/>},
                                    {path: "new-courses", element: <EditCourse/>},
                                    {path: "edit-courses/:id", element: <ManageCourses/>},
                                ]
                            }
                        ]
                    },

                ],
            },
            {
                path: "website",
                element: <AppLayoutWithSidebar/>,
                children: [
                    {index: true, element: <PostList/>},
                    {path: "post-list", element: <PostList/>},
                    {path: "post-add", element: <PostAdd/>},
                    {path: "post-edit/:id", element: <PostAdd/>},
                    {
                        path: "category-list",
                        element: <CategoryList section="post" createRoutePath="/app/website/category-add"/>
                    },
                    {
                        path: "category-add",
                        element: <CategoryAdd section="post" callback="/app/website/category-list"/>
                    },
                    {
                        path: "category-edit/:id",
                        element: <CategoryAdd section="post" callback="/app/website/category-list"/>
                    },


                    ...(process.env.APPLICATION === "fxpilot"
                        ? [
                            {path: "post-series-list", element: <PostSeriesList/>},
                            {path: "post-series-add", element: <PostSeriesAdd/>},
                            {path: "post-series-edit/:id", element: <PostSeriesAdd/>},
                        ]
                        : []),

                ],
            },
            {
                path: "support",
                element: <AppLayoutWithSidebar/>,
                children: [
                    {index: true, element: <TicketList/>},
                    {path: "ticket-list", element: <TicketList/>},
                    {path: "ticket-chat/:id", element: <TicketChat/>},
                    {
                        path: "category-list",
                        element: <CategoryList section="ticket" createRoutePath="/app/support/category-add"/>
                    },
                    {
                        path: "category-add",
                        element: <CategoryAdd section="ticket" callback="/app/support/category-list"/>
                    },
                    {
                        path: "category-edit/:id",
                        element: <CategoryAdd section="ticket" callback="/app/support/category-list"/>
                    },
                    {path: "withdraw-list", element: <WithdrawListAdmin/>},
                ],
            },
            process.env.APPLICATION === "fxpilot" &&
            {path: "cloud-storage", element: <CloudStorage/>},


        ],
    },
    {path: "signin", element: <CustomLogin/>},
    {path: "register", element: <Register/>},
    {path: "forgot-password", element: <ForgotPassword2/>},
    {path: "reset-password", element: <ResetPassword/>},
    {
        path: "errors",
        children: [
            {path: "404-classic", element: <Error404Classic/>},
            {path: "504-classic", element: <Error504Classic/>},
        ],
    },
    {path: "*", element: <Error404Classic/>},
]);